import axios from 'axios';
import queryString from 'query-string';
import Cookie from 'js-cookie';
import md5 from 'md5';
import { createModal } from './modals.js';

export default class Shortlist {

  init($) {
    this.api = axios.create({
      baseURL: process.env.NODE_ENV === 'test' ? 'http://hip.test/' : '/'
    });

    if (!Cookie.get('cookie_id')) {
      const n = Math.floor(Math.random() * 11);
      const k = Math.floor(Math.random() * 1000000);
      const uniqueId = String.fromCharCode(n) + k;

      Cookie.set('cookie_id', md5(uniqueId), 365 * 2, '/');
    }

    $('body').on('click', '.btn-shortlist', (e) => {
      e.preventDefault();
      const el = $(e.currentTarget);
      if (el.attr('data-action') === 'add') {
        this.add(el.attr('data-entity-id'), el.attr('data-entity-type'))
          .then((response) => {
            const data = response.data;
            if (data.success) {
              this.updateShortlistButton('add', el, data);
            } else {
              alert(data.message); // eslint-disable-line
            }
          });
      } else if (el.attr('data-action') === 'delete-full') {
        this.delete(el.attr('data-detail-id'), el.attr('data-user-id'))
          .then((response) => {
            const data = response.data;

            if (data.success) {
              el.closest('.shortlist-card').remove();
              if (!$('.shortlist-card').length) {
                window.location.reload();
              }
            } else {
              alert(data.message); // eslint-disable-line
            }
          });
      } else {
        this.delete(el.attr('data-detail-id'), el.attr('data-user-id'))
          .then((response) => {
            const data = response.data;

            if (data.success) {
              el.attr('data-detail-id', '');
              el.attr('data-action', 'add');
              el.html('<span class="icon"><i class="hui-icon-heart-o"></i></span>');
              this.updateShortlistButton('remove', el);
            } else {
              alert(data.message); // eslint-disable-line
            }
          });
      }
    });
  }

  add(entityId, entityType) {
    return this.api.post('/system/ajax_handlers/short_list.json.php', queryString.stringify({
      entity_id: entityId,
      entity_type: entityType
    }));
  }

  delete(shortlistDetailId, userId) {
    return this.api.post('/account/system/ajax_handlers/shortlist_action_handler.php', queryString.stringify({
      action: 'ShortListItemRemove',
      short_list_detail_id: shortlistDetailId,
      userId
    }));
  }

  updateShortlistButton(action, element, data = null) {
    if (action === 'add') {
      element.attr('data-detail-id', data.shortlistDetailId);
      element.attr('data-user-id', data.userId);
      element.attr('data-action', 'delete');
      element.attr('href', '#');
      element.removeClass('modal-trigger');
      element.unbind(createModal);
      element.html('<span class="icon"><i class="hui-icon-heart"></i></span>');
    } else if (action === 'remove') {
      element.attr('data-detail-id', '');
      element.attr('data-action', 'add');
      element.html('<span class="icon"><i class="hui-icon-heart-o"></i></span>');
    }
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/shortlist.js